import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ReadingListDetails } from '®shared/reading-list';
import { TarlV3Jsonapi } from '®shared/tarl-v3-jsonapi';

@Injectable({
  providedIn: 'root',
})
export class ListsForResourceService {
  constructor(private tarlV3Jsonapi: TarlV3Jsonapi) {}

  fetchListsForResource(resourceId: string): Observable<ReadingListDetails[]> {
    const path = this.tarlV3Jsonapi.path('/published_lists', {});
    const additionalParams = { 'filter[contains_resource_id]': resourceId };
    return this.tarlV3Jsonapi.getResources<ReadingListDetails>(
      path,
      {},
      additionalParams,
    );
  }
}
